
import ItemHeader from '@components/productDetail/ItemHeader';

import type { TSettingDetail } from '@types/setting';

export default function DescriptionAndPrice({
  setting
}: {
  setting: TSettingDetail
}) {
  return (
    <ItemHeader
      title={setting.short_description}
      price={setting.retail_price}
      bank_wire={setting.bank_wire_price}
      isPromoSetting={setting.is_promo_series}
      noCapitalize
    />
  );
}
